// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__3f0zx","gridColumns":"styles_gridColumns__3hTdP","gridColumn":"styles_gridColumn__Vcg9C"};